<div class="application-status-page">
  <main class="main-content">
    <p class="message">
      Your application has been approved! We're taking you to the login page.
    </p>
    <a href="{{ loginUrl }}" class="fallback-link">If you're stuck, click here</a>
  </main>
</div>
